import { RouterSuspense } from '@/common/components/RouterSuspense/RouterSuspense';
import { safeLazy } from '@/common/utils/import';

const { NewBudgetApplication } = safeLazy(
  () => import('@/web/containers/Budgets/Budgets')
);

export default function NewBudgetApplicationsPage() {
  return (
    <RouterSuspense>
      <NewBudgetApplication />
    </RouterSuspense>
  );
}
